<template>
  <section class="container columns" style="margin: 2% auto">
    <form v-on:submit.prevent="createProvincialManager" class="column is-half">
      <b-field label="Name">
        <b-input
          v-model="newProvincialManager.name"
          placeholder
          required
        ></b-input>
      </b-field>
      <b-field label="Email">
        <b-input
          v-model="newProvincialManager.email"
          placeholder
          required
        ></b-input>
      </b-field>
      <b-field label="Mobile Number">
        <b-input
          v-model="newProvincialManager.mobileNumber"
          placeholder
          required
        ></b-input>
      </b-field>
      <b-field
        label="Password"
        message="Password must contain at least 8 characters, including uppercase and lowercase letters, numbers, and special characters"
      >
        <b-input
          type="password"
          v-model="newProvincialManager.password"
          placeholder="Enter your password"
          required
          :class="{ 'is-danger': passwordInvalid }"
          :password-reveal="passwordReveal"
          @input="validatePassword"
        ></b-input>
        <b-icon
          :icon="passwordReveal ? 'eye' : 'eye-off'"
          :pack="passwordReveal ? 'fas' : 'far'"
          size="is-small"
          @click="passwordReveal = !passwordReveal"
          slot="password-reveal"
        ></b-icon>
      </b-field>
      <!-- <b-field label="Province">
        <b-input
          v-model="newProvincialManager.authorisedRegions"
          placeholder
          required
        ></b-input>
      </b-field> -->
      <b-field label="Province">
                <b-select v-model="newProvincialManager.authorisedRegions" placeholder="Select Province" :loading="provincesLoading == true" required>
                    <option
                        v-for="option in provinces"
                        :value="option._id"
                        :key="option._id">
                        {{ option.provinceName }}
                    </option>
                </b-select>
            </b-field>
      <div>
        <button class="button is-primary" type="submit">Create</button>
      </div>
    </form>
  </section>
</template>

<script>
import { currencies } from "@/helpers";
import { mapGetters } from "vuex";
export default {
  name: "NewProvincialManager",
  data() {
    return {
      equipmentTypes: [],
      provinces: [],
      currencies,
      newProvincialManager: {
        type: "provincial-manager",
        name: "",
        email: "",
        mobileNumber: "",
        password:"",
        authorisedRegions:[]
      }
      
    };
  },
  created() {
    this.getProvinces()
  },
  methods: {
    createProvincialManager() {
      const loading = this.$loading.open();

      this.$store
        .dispatch("createUser", this.newProvincialManager)
        .then(newProvincialManager => {
          loading.close();
          this.$router.push({ name: "Provincial Managers" });
          this.$toasted.global.success("Provincial Manager Created!");
        })
        .catch(e => {
          console.log("Exception when creating provincial manager", e);
          loading.close();
          this.$toasted.global.error("Failed to create provincial manager.");
        });
    },
    getProvinces() {
        this.provincesLoading = true;
        this.$store.dispatch('getProvinces').then(({meta,provinces})=> {
          this.provincesLoading = false;
          if(provinces && provinces.length) {
            this.provinces = provinces;
          } else {
            this.$toasted.global.error('Provinces not found.');
          }
        }).catch(e=> {
          this.provincesLoading = false;
          console.log('Exception when getting Provinces',e);
          this.$toasted.global.error('Failed to get Provinces.');
        })
      },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProvincialManagers/NewProvincialManager.vue